import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';

import {
  BaSeButton,
  BaSeCheckbox,
  BaSeContainer,
  BaSeDialogContext,
  BaSeFilePicker,
  BaSeLoading,
  BaSeParagraph,
  BaSeTheme,
} from '@base/react';
import {
  ButtonWrapper,
  FileMenagerContainer,
  SelectWrapper,
  FullBodyLoading,
} from './gestao-arquivos-styled';
import { CERTIFICADO_ANEXOS, PRODUTO_ENDPOINT } from '../../hooks/constants';

export const EnviarArquivos = ({
  setIsSendFile,
  setIsFileMenage,
  codigoProduto,
  isTemplateCertificados = false,
// eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [files, setFiles] = React.useState([]);
  const [selectedTransform, setSelectedTransform] = React.useState([]);
  const { backendPost } = Sebrae.useBackend();
  const { showNotification } = React.useContext(BaSeDialogContext);

  const { white } = BaSeTheme.colors.defaultColors;

  const endpointComponent = React.useMemo(
    () =>
      isTemplateCertificados
        ? CERTIFICADO_ANEXOS
        : `${PRODUTO_ENDPOINT}/${codigoProduto}/anexos`,
    [codigoProduto, isTemplateCertificados],
  );

  const cancelar = React.useCallback(() => {
    setIsSendFile(false);
    setIsFileMenage(true);
  }, [setIsFileMenage, setIsSendFile]);

  const sendFiles = React.useCallback(() => {
    if (files.length < 1) {
      showNotification({
        message: `Adicione pelo menos um arquivo`,
        color: 'attention',
      });
      return;
    }
    setIsLoading(true);
    const postData = new FormData();

    files.map((file) => postData.append('files', file));
    selectedTransform.map((transform) =>
      postData.append('transformacoes', transform.value),
    );

    const plural = files.length > 1 ? 's' : '';
    backendPost(`${endpointComponent}`, postData)
      .then(() => {
        showNotification({
          message: 'Envio finalizado',
          supportMessage: `${files.length} arquivo${plural} enviado${plural} com sucesso`,
          color: 'confirmation',
        });
      })
      .catch((error) => {
        showNotification({
          message: `Erro ao enviar arquivo${plural}`,
          color: 'destructive',
        });
      })
      .finally(() => {
        setIsLoading(false);
        cancelar();
      });
  }, [
    backendPost,
    cancelar,
    endpointComponent,
    files,
    selectedTransform,
    showNotification,
  ]);

  const valuesSelect = React.useMemo(
    () => [
      {
        id: 1,
        label: 'Todas minusculas',
        value: 'TODAS_MINUSCULAS',
      },
      {
        id: 2,
        label: 'Remover acentos',
        value: 'REMOVER_ACENTOS',
      },
      {
        id: 3,
        label: 'Substituir espaços em branco por"_"',
        value: 'SUBSTITUIR_ESPACO_POR_UNDERSCORE',
      },
      {
        id: 4,
        label: 'Substituir caracteres especiais por"_"',
        value: 'SUBSTITUIR_CARACTERES_ESPECIAIS_POR_UNDERSCORE',
      },
    ],
    [],
  );

  const values = React.useMemo(
    () => ({
      values: [...valuesSelect],
    }),
    [valuesSelect],
  );

  const handleCheckBoxChange = React.useCallback(
    (v) => {
      const item = selectedTransform.find((vv) => v.id === vv?.id);
      if (item) {
        setSelectedTransform((prev) => prev.filter((p) => p?.id !== item?.id));
        return;
      }
      setSelectedTransform((prev) => [...prev, v]);
    },
    [selectedTransform],
  );

  const checkAll = React.useCallback(() => {
    setSelectedTransform(
      selectedTransform.length === valuesSelect.length ? [] : [...valuesSelect],
    );
  }, [selectedTransform, valuesSelect]);

  const isChecked = React.useCallback(
    (v) => {
      return selectedTransform.find((vv) => vv?.id === v?.id);
    },
    [selectedTransform],
  );

  return (
    <div>
      {isLoading && (
        <FullBodyLoading>
          <BaSeLoading
            backgroundColor={
              BaSeTheme.colors.institucionais.azulSebrae10 + 'aa'
            }
            description=""
            spinnerColor={white}
            textColor={white}
            lightMode="default"
            shadowLevel={0}
            spinnerSize={24}
            text="Enviando arquivo…"
          />
        </FullBodyLoading>
      )}
      <BaSeContainer delimitedOnBreakpoint="desktop">
        <FileMenagerContainer>
          <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
            Arquivos selecionados
          </BaSeParagraph>
          <BaSeFilePicker
            acceptsFilesPattern={isTemplateCertificados ? 'image/*, .otf, .ttf' : "*"}
            onChange={setFiles}
            onError={function noRefCheck() {}}
            pickMultipleFiles
            renderStyle="box"
          />
          <SelectWrapper>
            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae45}
            >
              Transformar nomes dos arquivos
            </BaSeParagraph>
            <BaSeCheckbox
              label="Marcar todos"
              onChange={checkAll}
              checked={selectedTransform.length === valuesSelect.length}
            />
            {values.values?.map((v) => (
              <div key={v.id}>
                <BaSeCheckbox
                  checked={isChecked(v)}
                  key={v.id}
                  label={v.label}
                  value={v.value}
                  onChange={() => handleCheckBoxChange(v)}
                />
              </div>
            ))}
          </SelectWrapper>
          <ButtonWrapper>
            <BaSeButton
              value="Enviar arquivos"
              color={BaSeTheme.colors.institucionais.azulSebrae36}
              isLoading={isLoading}
              onClick={() => sendFiles()}
            />

            <BaSeButton
              value="Cancelar"
              type="secondary"
              color={BaSeTheme.colors.institucionais.azulSebrae36}
              onClick={() => cancelar()}
            />
          </ButtonWrapper>
        </FileMenagerContainer>
      </BaSeContainer>
    </div>
  );
};
